var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 11.3132 19.7413 12.6136 19.2388 13.8268C18.7362 15.0401 17.9997 16.1425 17.0711 17.0711C16.1425 17.9997 15.0401 18.7362 13.8268 19.2388C12.6136 19.7413 11.3132 20 10 20V10H20Z",
    fill: "#005857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.68678 20 7.38642 19.7413 6.17317 19.2388C4.95991 18.7362 3.85752 17.9997 2.92893 17.0711C2.00035 16.1425 1.26375 15.0401 0.761204 13.8268C0.258657 12.6136 -1.14805e-07 11.3132 0 10L10 10V20Z",
    fill: "#A90821"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C2.3186e-07 7.34783 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 -3.16267e-08 10 0V10L0 10Z",
    fill: "#FC9D2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.3132 1.566e-08 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10L10 10V0Z",
    fill: "#007A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGate);
export default __webpack_public_path__ + "static/media/Gate.025492d9.svg";
export { ForwardRef as ReactComponent };